import React from 'react';

import Select from 'react-select';

type Option<T> = { label: string; value: T | null };

interface Props<T> {
  includeBlank?: boolean;
  name?: string;
  options: Option<T>[];
  value: T | null;
  onChange: (changes: Record<string, T | null>, event: React.ChangeEvent<any>) => void;
  onValueChange: (value: T | null, event: React.ChangeEvent<any>) => void;
}

export default function ManagedReactSelectInput<T>({
  includeBlank,
  name,
  options,
  value,
  onChange,
  onValueChange,
  ...props
}: Props<T>) {
  function handleChange(option, event) {
    const { value } = option;
    onChange({ [name as string]: value }, event);
    onValueChange(value, event);
  }

  return (
    <Select
      {...props}
      options={options}
      value={options.find(option => option.value === value)}
      onChange={handleChange}
    />
  );
}
